import secureStorage from '@xpos/utils/src/secure.storage.utils';
import packageJson from '../../package.json';

let cachedDeviceUid: string | null = null;
let cachedMerchantUid: string | null = null;
let cachedPlatform: string | null = null;
function getInfo(): { deviceUid: string, merchantUid: string, platform: string } {
    if (!cachedDeviceUid || cachedDeviceUid === 'unknown') {
        cachedDeviceUid = secureStorage.getItem('device_uid') || 'unknown';
    }
    if (!cachedMerchantUid || cachedMerchantUid === 'unknown') {
        cachedMerchantUid = secureStorage.getItem('merchant_uid') || 'unknown';
    }
    if (!cachedPlatform || cachedPlatform === 'unknown') {
        cachedPlatform = localStorage.getItem('platform') || 'unknown';
    }
    return { deviceUid: cachedDeviceUid, merchantUid: cachedMerchantUid, platform: cachedPlatform };
}

function logInfo(message: string, infoObject: Record<string, any> = {}) {
  const logData = {
      message,
      info: infoObject
  };

  sendLog(logData);
}

function logError(message: string, errorObject: Record<string, any> = {}) {
  const logData = {
      message,
      status: 'error',
      error: errorObject
  };
  sendLog(logData);
}

// WebKit bug: IndexedDB cursor dies after app backgrounds/resumes (dexie/Dexie.js#2008)
function isLiveQueryCursorError(err: any): boolean {
  return !!err?.message?.includes('cursor');
}

// Log liveQuery errors, extract safe error info to avoid circular reference
function logLiveQueryError(err: any, context: Record<string, any> = {}) {
  if (isLiveQueryCursorError(err)) return;
  logError('Dexie liveQuery failed', {
    name: err?.name,
    message: err?.message,
    stack: err?._stack || err?.stack,
    innerName: err?.inner?.name,
    innerMessage: err?.inner?.message,
    innerStack: err?.inner?._stack,
    ...context
  });
}



function sendLog(data: Record<string, any>) {
  const { deviceUid, merchantUid, platform } = getInfo();
  const logPayload = {
      ...data,
      ddsource: 'capacitor.js',
      hostname: platform,
      service: 'posx',
      env: import.meta.env.VITE_IS_PROD === 'true' ? 'production' : 'development',
      version: packageJson.version,
      device_uid: deviceUid,
      merchant_uid: merchantUid
  };

  fetch('https://logs.xposhq.com/', {
      method: 'POST',
      headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer nRXpIXTQ2TVIAHaSntyjfvQB90LI3LGYgXayDe7URGvXkQfGiR'
      },
      body: JSON.stringify(logPayload)
  }).catch(console.error);
}

function serializeError(err: unknown): Record<string, any> {
    if (!(err instanceof Error)) return { message: String(err) };
    return { message: err.message, name: err.name, stack: err.stack };
}

export { logInfo, logError, logLiveQueryError, serializeError, isLiveQueryCursorError };
